goog.provide('el8.appchart.medsHx.reconciler');

goog.require('el8.ptdata.medOrders');
goog.require('el8.ptdata.dcMedOrders');
goog.require('el8.appchart.medsMgr');
goog.require('el8.uiwidget.ButtonSet');


el8.appchart.medsHx.reconciler = function(spec) {

    this._container = spec.container;
    this._drawerContainer = spec.drawerContainer;
    this._renderer = spec.renderer;
    this._openReconcileDrawerFn = spec.openReconcileDrawerFn;
    this._closeReconcileDrawerFn = spec.closeReconcileDrawerFn;

    this._currOrderIdToMove = null;
    this._currAssocOrderIdToMove = null;
    this._currThreadIdToMerge = null;
};

el8.appchart.medsHx.reconciler.prototype.reset = function() {
    this._currOrderIdToMove = null;
    this._currAssocOrderIdToMove = null;
    this._currThreadIdToMerge = null;
};

/**
 * Support for moving orders across threads
 */
el8.appchart.medsHx.reconciler.prototype.beginOrderMove = function(orderId) {

    this._currOrderIdToMove = null;
    this._currAssocOrderIdToMove = null;

    /* Highlight the order and associated order (if any) */
    if (el8.model.idToModelClass(orderId) === 'MedOrder') {
        var order = el8.ptdata.medOrders.getById(orderId);
    } else if (el8.model.idToModelClass(orderId) === 'DiscontinueMedOrder') {
        var order = el8.ptdata.dcMedOrders.getById(orderId);
    }
    this._currOrderIdToMove = orderId;
    var associatedOrder = this._getAssociatedOrder(order);
    if (associatedOrder) { 
        this._renderer.highlight([orderId, associatedOrder.getId()], false);
        this._currAssocOrderIdToMove = associatedOrder.getId();
    } else {
        this._renderer.highlight(orderId, false);
    }

    /* Show reconcile drawer */
    this._openReconcileDrawerFn({
        exceptThreadId: order.getThreadId(),
        type: 'move-order'
    });
};
el8.appchart.medsHx.reconciler.prototype._getAssociatedOrder = function(order) {
    if (order.is('DiscontinueMedOrder')) {
        return el8.ptdata.medOrders.getById(order.getMedOrderId());
    } else { // is MedOrder
        var thread = el8.ptdata.medOrderThreads.getById(order.getThreadId());
        var dcMedOrder = thread.getAssociatedDcOrder(order.getId());
        return dcMedOrder || null;
    }
};
el8.appchart.medsHx.reconciler.prototype.moveOrder = function(threadId, isPermanent, isRx) {
    var that = this;
    if (this._currAssocOrderIdToMove) {
        el8.uiwidget.confirm(
            'Both the selected order and its associated order (also highlighted) will be moved.  Proceed?',
            function() { 
                that._closeReconcileDrawerFn();
                el8.appchart.medsMgr.moveOrderToThread(that._currOrderIdToMove, 
                    threadId, isPermanent, isRx);
            },
            function() { that._closeReconcileDrawerFn(); }
        );
    } else {
        el8.appchart.medsMgr.moveOrderToThread(this._currOrderIdToMove, 
            threadId, isPermanent, isRx);
        this._closeReconcileDrawerFn();
    }
};

/**
 * Support for merging threads
 */
el8.appchart.medsHx.reconciler.prototype.beginThreadMerge = function(threadId) {
    this._currThreadIdToMerge = threadId;
    this._renderer.highlight(threadId, false);
    this._openReconcileDrawerFn({
        exceptThreadId: threadId,
        type: 'merge-thread'
    });
};
el8.appchart.medsHx.reconciler.prototype.mergeThread = function(destThreadIds) {
    el8.appchart.medsMgr.mergeThreads(this._currThreadIdToMerge, destThreadIds);
    this._closeReconcileDrawerFn();
};

/**
 * Move fills
 */
el8.appchart.medsHx.reconciler.prototype.beginFillMove = function(fillId) {
    this._currFillIdToMove = fillId;
    this._renderer.highlight(fillId, false);
    var fill = el8.ptdata.medOrderFills.getById(fillId);
    var thread = el8.ptdata.medOrderThreads.getById(fill.getThreadId());
    this._openReconcileDrawerFn({
        exceptOrderId: fill.getMedOrderId(),
        orderIds: thread.getAllOrderIds()
    });
};
el8.appchart.medsHx.reconciler.prototype.moveFillToOrder = function(orderId) {
    el8.appchart.medsMgr.moveFillToOrder(this._currFillIdToMove, orderId);
    this._closeReconcileDrawerFn();
};

/**
 * Create button sets
 */
el8.appchart.medsHx.reconciler.prototype.getMergeButtonSet = function(container, 
        buttonElt, type) {
    var buttonSet = new el8.uiwidget.ButtonSet();
    buttonSet.setContainer(buttonElt);
    var that = this;
    if (type === 'move-order') {
        buttonSet.addButton('move', 'Move Order into Selected Med', function() {
            var selected = $(':input[name="mergeThreadTarget"]', container).filter(':checked');
            if (!selected.length) {
                el8.uiwidget.alert('Please select a med to move order into.');
            } else {
                var val = selected.val();
                if (isNaN(parseInt(val, 10))) {
                    that.moveOrder(null, val.startswith('perm'), val.endswith('rx'));
                } else {
                    that.moveOrder(val*1);
                }
            }
        }, true);
    } else {
        buttonSet.addButton('merge', 'Merge with Selected Med(s)', function() {
            var selectedIds = [];
            $(':input[name="mergeThreadTarget"]', container).filter(':checked')
                .each(function(index, elt) {
                    selectedIds.push($(elt).val());
                });
            if (!selectedIds.length) {
                el8.uiwidget.alert('Please select at least one med to merge with.');
            } else{
                that.mergeThread(selectedIds);
            }
        }, true);
    }
    buttonSet.addButton('cancel', 'Cancel', function() {
        that._closeReconcileDrawerFn();
    }, false);
    return buttonSet;
};
el8.appchart.medsHx.reconciler.prototype.getMoveFillButtonSet = function(container, 
        buttonElt) {
    var buttonSet = new el8.uiwidget.ButtonSet();
    buttonSet.setContainer(buttonElt);
    var that = this;
    buttonSet.addButton('move', 'Move to Selected Order', function() {
        var selected = $(':input[name="moveFillTarget"]', container).filter(':checked');
        if (!selected.length) {
            el8.uiwidget.alert('Please select an order to move fill to.');
        } else{
            var val = selected.val();
            that.moveFillToOrder(val ? val*1 : null);
        }
    }, true);
    buttonSet.addButton('cancel', 'Cancel', function() {
        that._closeReconcileDrawerFn();
    }, false);
    return buttonSet;
};


